/**
 * Shared issue utility functions.
 */

/**
 * Format an age date into a short label.
 * Returns null if no date is provided.
 */
export function formatAge(dateStr?: string | null): string | null {
  if (!dateStr) return null;
  const ms = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(ms / 86400000);
  if (days < 1) return "Today";
  if (days === 1) return "1d";
  if (days < 30) return `${days}d`;
  const months = Math.floor(days / 30);
  return `${months}mo`;
}
